module.exports = __webpack_public_path__ + "img/company-documents.b7918e80.svg";